<template>
  <div>
  <v-dialog v-model="visible" width="90vw" max-width="780" persistent>
    <v-card>

      <!-- Header -->
      <div class="modal-header px-6 pt-5 pb-4 d-flex align-center justify-space-between">
        <div>
          <div class="text-h6 font-weight-bold">Order Items</div>
          <div class="text-caption grey--text text--darken-1 mt-1">
            Order #{{ order.id }}
            <span v-if="order.billing" class="ml-1">· {{ order.billing.first_name }} {{ order.billing.last_name }}</span>
          </div>
        </div>
        <div class="d-flex align-center" style="gap: 8px;">
          <v-chip v-if="gift" small color="pink lighten-4" text-color="pink darken-3">
            <v-icon left small>mdi-gift</v-icon> Gift Wrap
          </v-chip>
          <v-chip v-if="expressDelivery" small color="orange lighten-4" text-color="orange darken-3">
            <v-icon left small>mdi-lightning-bolt</v-icon> Express
          </v-chip>
          <v-btn icon small @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <v-divider />

      <!-- Items list -->
      <v-card-text class="pa-0">
        <div
          v-for="(item, idx) in order.line_items"
          :key="item.id"
        >
          <div class="item-row px-6 py-4 d-flex align-center" style="gap: 20px;">
            <!-- Image -->
            <div class="item-img-wrap flex-shrink-0" @click="previewSrc = item.image && item.image.src; previewOpen = true">
              <img :src="item.image && item.image.src" :alt="item.name" class="item-img" />
              <div class="img-zoom-hint"><v-icon color="white" small>mdi-magnify-plus</v-icon></div>
            </div>
            <!-- Details -->
            <div class="flex-grow-1">
              <div class="text-subtitle-1 font-weight-medium item-name mb-2">{{ item.name }}</div>
              <div class="d-flex flex-wrap" style="gap: 8px;">
                <v-chip small outlined color="grey darken-2">
                  <v-icon left x-small>mdi-barcode</v-icon>{{ item.sku }}
                </v-chip>
                <v-chip small outlined color="primary">
                  <v-icon left x-small>mdi-layers</v-icon>Qty: {{ item.quantity }}
                </v-chip>
                <v-chip v-if="item.price" small outlined color="green darken-1">
                  <v-icon left x-small>mdi-currency-inr</v-icon>{{ item.price }}
                </v-chip>
              </div>
            </div>
          </div>
          <v-divider v-if="idx < order.line_items.length - 1" />
        </div>

        <!-- Gift message -->
        <div v-if="giftMessage" class="px-6 pb-4">
          <v-alert
            dense
            text
            color="deep-purple"
            icon="mdi-message-text"
            class="mt-2 mb-0"
          >
            <div class="text-caption font-weight-bold text-uppercase mb-1" style="letter-spacing:.05em;">Gift Message</div>
            <div class="text-body-2">{{ customMessage }}</div>
          </v-alert>
        </div>
      </v-card-text>

      <v-divider />

      <!-- Footer actions -->
      <v-card-actions class="px-6 py-4">
        <v-spacer />
        <v-btn text color="grey darken-1" @click="close">
          {{ order.status === 'processing' ? 'Cancel' : 'Close' }}
        </v-btn>
        <v-btn
          v-if="order.status === 'processing'"
          color="primary"
          depressed
          @click="confirmPacking"
        >
          <v-icon left small>mdi-check</v-icon>
          Confirm Packing
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>

  <!-- Image preview dialog -->
  <v-dialog v-model="previewOpen" max-width="600" @click:outside="previewOpen = false">
    <v-card class="pa-2" style="background:#000;">
      <img :src="previewSrc" style="width:100%;height:auto;display:block;border-radius:4px;" />
      <v-btn icon dark absolute top right @click="previewOpen = false" style="top:8px;right:8px;">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
export default {
    props: ['order', 'gift', 'close', "expressDelivery", "giftMessage", "customMessage"],
    data() {
        return {
            visible: false,
            previewOpen: false,
            previewSrc: "",
        };
    },
    mounted() {



    },
    methods: {
        confirmPacking() {

            this.$emit('confirmPacking', this.order);
            // this.$emit('resetFlags'); // Emit an event to reset flags
            this.visible = false;
        }
    }
};
</script>
<style scoped>
.item-img-wrap {
  width: 110px;
  height: 110px;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: zoom-in;
  position: relative;
}
.item-img-wrap .img-zoom-hint {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity .18s;
  border-radius: 8px;
}
.item-img-wrap:hover .img-zoom-hint {
  opacity: 1;
}
.item-img {
  width: 110px;
  height: 110px;
  object-fit: cover;
}
.item-name {
  white-space: normal;
  line-height: 1.4;
}
.item-row:hover {
  background: #fafafa;
}
.item-row ::v-deep .v-chip {
  font-size: 14px;
}
</style>